import { useEffect } from 'react';
import { API_BASE } from '@/lib/api';
import { useAuth } from '@/lib/auth_context';

function deviceType() {
  const ua = navigator.userAgent || '';
  if (/ipad|tablet/i.test(ua) || (/android/i.test(ua) && !/mobile/i.test(ua))) return 'tablet';
  if (navigator.userAgentData?.mobile || /mobi|iphone|ipod|android/i.test(ua)) return 'mobile';
  return 'desktop';
}

export const useLoomPresence = (currentArea) => {
  const { user } = useAuth();

  useEffect(() => {
    if (!user || !currentArea) return undefined;
    let active = true;
    const sendHeartbeat = async () => {
      if (!active) return;
      try {
        await fetch(`${API_BASE}/loom/heartbeat`, {
          method: 'POST',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ current_area: currentArea, device_type: deviceType() }),
        });
      } catch {
        // Presence is best-effort and must never interrupt writing.
      }
    };
    const onVisible = () => {
      if (document.visibilityState === 'visible') sendHeartbeat();
    };
    sendHeartbeat();
    const timer = window.setInterval(sendHeartbeat, 30_000);
    window.addEventListener('focus', sendHeartbeat);
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      active = false;
      window.clearInterval(timer);
      window.removeEventListener('focus', sendHeartbeat);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [currentArea, user]);
};